<template>
  <div class="life_costs-pages-index content-container" id="life_costs-pages-index">
    <div class="inexplain">
      <img src="//static.dmall.com.hk/kayak-project/partner/dist/partner/common/images/welcome.png" />
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>
.life_costs-pages-index {
	background: #fff;
	width: 100%;
	height: 100%;
	overflow: auto;
}
.life_costs-pages-index .inexplain {
	display: flex;
  align-items: center;
  justify-content: center;
	height: 100%;
}
.life_costs-pages-index .inexplain h3 {
	font-size: 40px;
	color: #403E88;
	letter-spacing: 0;
	font-weight: lighter;
}
.life_costs-pages-index .inexplain p {
	font-size: 20px;
	color: #403E88;
	letter-spacing: 0;
	margin-top: 32px;
	font-weight: lighter;
}
.life_costs-pages-index .inexplain img{
	width: 30%;
}
</style>